import { render, staticRenderFns } from "./DeliveryPickpoint.vue?vue&type=template&id=5ac7f7e2&scoped=true&"
import script from "./DeliveryPickpoint.vue?vue&type=script&lang=js&"
export * from "./DeliveryPickpoint.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPickpoint.vue?vue&type=style&index=0&id=5ac7f7e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac7f7e2",
  null
  
)

export default component.exports